/* eslint-disable @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access, 	@typescript-eslint/no-unused-vars, @typescript-eslint/no-floating-promises, @typescript-eslint/no-misused-promises, 	@typescript-eslint/no-unsafe-assignment, 	@typescript-eslint/no-var-requires, @typescript-eslint/unbound-method, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unnecessary-type-assertion   */
import React from 'react';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import * as dateFns from 'date-fns';
import chainStampCardstore from 'stores/next/stampCard';
import StoreStore from 'stores/next/stores';
import page from 'components/next/pages/page/page';
import Spinner from 'components/common/next/spinner';
import SidebarWrapper from 'components/next/components/sidebar/sidebar';
import { ReactComponent as IconDelete } from '@kesko/icons/action/icon-delete.svg';
import { ReactComponent as IconArrowRight } from '@kesko/icons/nav/icon-arrow-right.svg';
import { castDate } from 'utils/helpers';
import { ChainAbbreviations, kRautaChainIds, onninenChainIds } from 'constants/common';
import { CollectionStampCardStatus, CollectionStampCardType } from 'enums/stampCard';
import type { Store, CollectionStampCard } from 'types/next';
import './chainStampCards.scss';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { createKeskoStampCard, viewKeskoStampCard } from 'components/next/routes';
import SidebarFilterStore from 'stores/next/sidebarFilters';
import SidebarFilters from 'components/next/components/sidebar/filter';

interface State {
  query: string;
  chainIds: string[];
  storeIds: string[];
  isLoading: boolean;
  message?: string;
  order: 'asc' | 'desc';
  sort?: string;
  searchResult: CollectionStampCard[];
  statuses: { [type: string]: boolean };
  stores: Store[];
}

interface Props {
  stampCardStore: chainStampCardstore;
  storeStore: StoreStore;
  stampCardsSidebarFilterStore?: SidebarFilterStore;
}

@inject('stampCardStore', 'storeStore', 'stampCardsSidebarFilterStore')
@observer
class ChainStampCards extends React.Component<Props, State> {
  debouncedSearchChainStampCards: () => void;

  constructor(props) {
    super(props);
    this.state = {
      query: '',
      chainIds: ['3', '4', '5'],
      storeIds: [],
      stores: [],
      sort: 'activeFrom',
      order: 'asc',
      message: null,
      isLoading: true,
      statuses: _.reduce(
        Object.keys(CollectionStampCardStatus),
        (statuses, key) => {
          const status = CollectionStampCardStatus[key as string];
          statuses[status] = true;
          return statuses;
        },
        {},
      ),
      searchResult: [],
    };
    this.debouncedSearchChainStampCards = _.debounce(this.searchChainStampCards, 500);
  }

  get chainStampCards() {
    return this.state.searchResult;
  }

  get stampCardStore() {
    return this.props.stampCardStore;
  }

  get filterStore() {
    return this.props.stampCardsSidebarFilterStore;
  }

  get storeStore() {
    return this.props.storeStore;
  }

  componentDidMount = async () => {
    await this.searchChainStampCards();
    const stores = await this.storeStore.searchStores({});
    this.filterStore.setSort('activeFrom');
    this.filterStore.setOrder('asc');
    this.setState({ stores });
  };

  searchChainStampCards = async (limit = 0) => {
    const { stampCardStore } = this.props;
    const { chainIds, sort, order, query, statuses, storeIds } = this.filterStore;

    const statusKeys = _.keys(_.pickBy(statuses, Boolean));
    const status: string = statusKeys.length === 1 ? _.first(statusKeys) : null;
    const search = _.omitBy(
      {
        keskoStampCard: true,
        query,
        chainId: chainIds,
        ...(storeIds.length > 0 && { storeId: storeIds }),
        status,
      },
      _.isNil,
    );

    try {
      const chainStampCards = await stampCardStore.searchCollectionStampCards({
        payload: search,
        params: {
          limit,
          sort: 'activeFrom',
          order: 'asc',
        },
      });
      const searchResult = chainStampCards.data.result as CollectionStampCard[];

      this.setState({
        searchResult,
        isLoading: false,
      });
    } catch (err) {
      this.setState({ isLoading: false });
    }
  };

  // eslint-disable-next-line
  handleChainStampcardQueryChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    if (name === 'query') {
      this.setState({ isLoading: true });
      this.filterStore.setQuery(value);
      this.debouncedSearchChainStampCards();
    }
  };

  handleResetFilters = () => {
    if (this.filterStore.isDirty(['query', 'chainIds'])) {
      this.filterStore.reset(['3', '4', '5']);
      this.setState({ chainIds: ['3', '4', '5'], isLoading: true });
      this.debouncedSearchChainStampCards();
    }
  };
  handleChainStampcardChainChange = (chain: string) => {
    const chainIds = [...this.filterStore.chainIds];
    if (chainIds.includes(chain)) {
      _.pullAt(chainIds, chainIds.indexOf(chain));
    } else {
      chainIds.push(chain);
    }
    this.setState({ isLoading: true });
    this.filterStore.setChainIds(chainIds);
    this.debouncedSearchChainStampCards();
  };

  handleStoresChange = (stores: Store[]) => {
    this.setState({ isLoading: true, storeIds: _.map(stores, 'storeId') });
    this.debouncedSearchChainStampCards();
  };

  handleStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { statuses } = this.state;
    const status = e.currentTarget.dataset.chainStampCardstatus;
    statuses[status] = !statuses[status];
    this.setState({ statuses, isLoading: true });
    this.debouncedSearchChainStampCards();
  };

  renderKeskoStampCardSidebar = () => {
    const { isLoading } = this.state;
    const navigate = useNavigate();
    const { chain: chainParam } = useParams();
    return (
      <div className="collection-stamp-card-templates-sidebar">
        <div className="collection-stamp-card-templates-filters">
          <button
            className="add-button sidebar-button"
            onClick={() => navigate(createKeskoStampCard.readyLink(chainParam, 'type'))}
            // onClick={() => navigate(getLink('stampCardEditor', 'create', _.get(template, ['id']), 'type'))}
          >
            <span>Create Stamp Card</span>
            <img src={require('images/add-nega.svg').default} alt="add" />
          </button>
          <div className="sidebar__title-wrapper">
            <h3 className="sidebar__title">Filters</h3>
            {isLoading && <Spinner addClassName="spinner--unset" />}
          </div>
          <SidebarFilters
            query={this.filterStore.query}
            chainIds={this.filterStore.chainIds}
            handleQueryChange={this.handleChainStampcardQueryChange}
            excludedChains={[...kRautaChainIds, ...onninenChainIds]}
            handleChainChange={this.handleChainStampcardChainChange}
            searchBoxMessage="Search for Chain Stamp Card title or ID"
            searchBoxPlaceholderMessage="Search for Chain Stamp Card"
          />
        </div>
      </div>
    );
  };

  getHeaderClass = (field: string) => {
    const { sort, order } = this.state;

    if (field !== sort) {
      return '';
    }

    return ` sorted ${order}`;
  };

  getchainStampCardstatus = (activeFrom: string, activeTo: string) => {
    const today = new Date();

    if (dateFns.isBefore(new Date(activeTo), today)) {
      return 'passed';
    }

    if (dateFns.isAfter(new Date(activeFrom), today)) {
      return 'upcoming';
    }

    return 'active';
  };

  getCollectionStampCardType = (type: CollectionStampCardType) => {
    switch (type) {
      default:
      case CollectionStampCardType.Product:
        return 'Product collecting';
      case CollectionStampCardType.Basket:
        return 'One time purchase';
    }
  };

  delete = async (cardId: string) => {
    const confirmed = window.confirm(
      'Are you sure you want to delete this collection stamp card? This action cannot be undone.',
    );

    if (confirmed) {
      await this.stampCardStore.deleteCollectionStampCard(cardId, false);
      this.searchChainStampCards();
    }
  };

  renderCollectionStampCardRows = () => {
    const dateFormat = 'd.M.yyyy';

    if (!this.chainStampCards) {
      return null;
    }

    return (
      <tbody id="collectionStampCard-table-body">
        {this.chainStampCards.map((c) => (
          <tr key={c.id} className="collectionStampCard-row">
            <td>{c.id}</td>
            <td>{_.get(c, ['uiData', 'uiName', 'fi'])}</td>
            <td>
              {c.chains?.map((c, i) => (
                <span className={`chain-name ${ChainAbbreviations[c]}`} key={`chain-${i}`}>
                  {ChainAbbreviations[c]}
                </span>
              ))}
            </td>
            <td>{c.tosData?.offerNumber}</td>
            <td>{c.campaignId}</td>
            <td>{this.getCollectionStampCardType(c.type as CollectionStampCardType)}</td>
            <td>{dateFns.format(castDate(c.activeFrom), dateFormat)}</td>
            <td>{dateFns.format(castDate(c.activeTo), dateFormat)}</td>
            <td>{dateFns.format(castDate(c.redeemableTo), dateFormat)}</td>
            <td>{this.getchainStampCardstatus(c.activeFrom, c.activeTo)}</td>
            <td>
              <NavLink to={viewKeskoStampCard.readyLink('k-ruoka', c.id)}>
                <IconArrowRight />
              </NavLink>
              <button onClick={() => this.delete(_.get(c, ['id']))}>
                <IconDelete />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    );
  };

  render() {
    const { isLoading } = this.state;

    return (
      <SidebarWrapper renderSidebar={this.renderKeskoStampCardSidebar}>
        <div className="chainStampCards">
          <div className="table-container">
            <table className="styled">
              <thead>
                <tr>
                  <th className={this.getHeaderClass('id')}>Id</th>
                  <th className={this.getHeaderClass('uiData.title.fi')}>Title</th>
                  <th className={this.getHeaderClass('storeId')}>{'Chains'}</th>
                  <th className={this.getHeaderClass('offerNumber')}>Offer number</th>
                  <th className={this.getHeaderClass('campaignId')}>Stamp collecting Id</th>
                  <th className={this.getHeaderClass('type')}>Type</th>
                  <th className={this.getHeaderClass('activeFrom')}>Active from</th>
                  <th className={this.getHeaderClass('activeTo')}>Active to</th>
                  <th className={this.getHeaderClass('redeemableTo')}>Redeemable to</th>

                  <th className={this.getHeaderClass('status')}>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              {this.renderCollectionStampCardRows()}
            </table>
          </div>
          {isLoading && <Spinner />}
        </div>
      </SidebarWrapper>
    );
  }
}

export default page(ChainStampCards);
